import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class EncodeContentTypeInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedRequest: HttpRequest<any> = request.clone({
      setHeaders: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    return next.handle(modifiedRequest);
  }
}
